import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ReactComponent as IconChevronRight } from '@/assets/svgs/chevron-right.svg'
import { ReactComponent as IconDataElement } from '@/assets/svgs/data-element-grey.svg'
import { ReactComponent as IconDocument } from '@/assets/svgs/document-grey.svg'
import { ReactComponent as IconMenu } from '@/assets/svgs/menu-light.svg'
import { ReactComponent as IconNoMessage } from '@/assets/svgs/no-message.svg'
import MenuDropDown from '@/components/MenuDropDown'
import { ToastContext } from '@/context/toast/index.js'
import useModal from '@/hooks/use-modal/index'
import useStaticData from "@/hooks/use-static-data/index"
import { useLocation, useNavigate } from '@/lib/router-dom/index'
import api from "@/services/api/eclips.js"
import moment from 'moment'
import { Fragment, useContext, useState } from 'react'
import ConfirmDeclineModal from './confirm-decline-modal.jsx'
import MoveFolderModal from './move-folder-modal.jsx'
import PinToTop from './pin-to-top.jsx'

export default function EclipDataTable({ items,
	meta,
	pageLimit,
	currentPage,
	goToPrev,
	goToNext,
	setLoading,
	setSortConfig,
	sortConfig,
	handleCurrnetInput,
}) {

	const { goTo } = useNavigate();
	const { currentPath } = useLocation();
	// const type = currentPath.includes('shared') ? 'RECEIVE' : 'SEND'

	const { visible: isConfirmDeclineModalVisible, show: showConfirmDeclineModal, hide: hideConfirmDeclineModal } = useModal();
	const { visible: isShowMoveEcliptoFolderModal, show: showEcliptoFolderFolderModal, hide: hideEcliptoFolderModel } = useModal()

	const onDeclineConfirm = async (item,message) => {
		setLoading(true);
		hideConfirmDeclineModal();
		await api.declineRequest(item.id, {message})
		document.getElementById("reload-eclips")?.click();
		addToastMessage("Declined package successfully", "success");
	};


	const { addToastMessage } = useContext(ToastContext)

	const [selectedItem, setSelectedItem] = useState('');

	const staticData = useStaticData();

	function getClassName(name) {
		if (!sortConfig) {
			return
		}
		return sortConfig.key === name ? (sortConfig.direction === true ? "is-asc" : "is-desc") : ""
	}


	function handleSort(key) {
		let direction = sortConfig.direction
		if (sortConfig.key === key) {
			direction = !direction
		} else {
			direction = true
		}

		const sortDirection = direction === true ? "ASC" : "DESC";

		setSortConfig({ key, direction })
	}
	const isShared = currentPath.includes('shared')

	const handleClick = (item) => {

		if (item?.badge === 'PACKAGE_DECLINED' && item?.request) {
		addToastMessage('Package Declined', 'error')
		return;
		}
		if (item?.badge === 'PACKAGE_ACCEPTED') {
		if (isShared) {
			addToastMessage('No data available yet', 'error')
			return;
		}
		}
		if (item?.badge === 'PACKAGE_REQUESTED') {
		if (isShared) {
			addToastMessage('Receipient has not responded yet', 'error')
			return;
		}
		goTo(`/eclip/respond/${item.id}`)
		return;
		}

		goTo(`/eclip/send/${item.id}`)
	}

	const list = items?.map((item, index) => {
		const consumerOrgInfo = item.receivingType === "COPY" && staticData?.orgs?.find((org) => org.orgId === item.consumedOrgId)

		return (
			<Fragment key={index}>
				<div className="data-table__table__body__row data-table__table__body__row--modified" key={index}>
					<div className="data-table__table__body__content--text data-table__table__body__content--heavy data-table__table__head__content--name">
						<div className='flex-center eclip-data-table__row-content'>
							<PinToTop pinned={item.pinned} eclipId={item.id} />
							<div className="data-table__package-name">
								{item.name || '---'}
								{consumerOrgInfo && (
									<div className="eclip-data-table__bottom-content__org-name">Consumed by {consumerOrgInfo.name}</div>
								)}
							</div>
							{item.receivingType === "COPY" && (
								<div className="eclip-landing-data-table__copy-lable tooltip">
									<span className="tooltiptext tooltiptext__copy-label">
										Copy of the data shared by your data provider
									</span>
									COPY
								</div>
							)}
						</div>
					</div>
					<div className="data-table__table__body__content data-table__table__head__title--destination">
						{item.recipients?.find(recipient => recipient.selected)?.name || '---'}
					</div>
					<div className="data-table__table__body__content data-table__table__head__title--reference-number">
						{item.referenceNumber || '---'}
					</div>

					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__head__title--eclip-stats">
						<div className="eclip-card__summary">
							<div>
								<IconDataElement />
								<span>{String(item?.dataElementsCount).padStart(2, '0')}</span>
							</div>
							<div>
								<IconDocument />
								<span>{String(item?.attachmentsCount).padStart(2, '0')}</span>
							</div>
						</div>
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__head__title--status">
						<div className={`data-table--eclip-status data-table__status--box-modified  ${item.badge} ${(item?.badge === null && item?.completionPercentage !== 0) ? `data-table__completed--status` : ``}`}>
							{(item?.badge === null && item?.completionPercentage === 0) ? `NO DATA UPLOADED` : (item?.badge === null && item?.completionPercentage !== 0) ? item?.completionPercentage + `% COMPLETED` :
								item?.badge === 'REQUESTED' ? 'MORE INFO REQUIRED' : item?.badge.split('_').join(' ')}
						</div>
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__head__title--modified">
						{moment(item.modified).format('DD/MM/yyyy, hh:mm a') || '---'}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__head__title--created-by data-table__table__body__content--package-owner">
						{(currentPath.includes('shared') ? item.receiveOwner : item.sendOwner) || '---'}
					</div>
					{/* <div className="data-table__table__body__content data-table__table__body__content--text data-table__table__head__title--view-details data-table__table__body__content--modified">
					<span className="data-table__table__body__content__action link tooltip"
						onClick={() => goTo(`/eclip/folder/${item.id}/${type}`)}
					>
						<span className="tooltiptext">View Details</span>
						<IconChevronRight />
					</span>
				</div> */}
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--end data-table__table__body--end">
						<span className="data-table__table__body__content__action link tooltip data-table__table--toolitp"
							// onClick={() => goTo(`/eclip/send/${item.id}`)}
							onClick={() => handleClick(item)}
						>
							<span className="tooltiptext">View Details</span>
							<IconChevronRight />
						</span>
						<MenuDropDown
							button={(props) => (
								<span className="eclip-landing_cursor-mode__pointer eclip-table--menu" {...props}>
									<IconMenu />
								</span>
							)}
							list={[
								{
									label: 'Move',
									onClick: (e) => { e.stopPropagation(); setSelectedItem(item); showEcliptoFolderFolderModal() },
								},
								(isShared && item.badge !== 'PACKAGE_DECLINED') && !item.request
									? {
											label: "Decline",
											onClick: (e) => {
												e.stopPropagation();
												setSelectedItem(item);
												showConfirmDeclineModal();
											},
									}
									: undefined,
							]}
						/>
					</div>

				</div>
			</Fragment>
		)
	})

	function getPageStart(pageSize, pageNr) {
		return pageSize * pageNr;
	};

	function getPageLabel(total, pageSize, pageNr) {
		if(isNaN(pageNr)){
			pageNr = 0;
		}
		const start = Math.max(
			getPageStart(pageSize, pageNr),
			0
		);
		const end = Math.min(
			getPageStart(pageSize, pageNr + 1),
			total
		);

		return `${start + 1} - ${end}`;
	}

	const NoMessage = () => {
		return (
			<div className="data-table__empty__icon">
				<IconNoMessage />
			</div>
		)
	}

	return (
		<>
			<div className="data-table__content eclip-data-table">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row data-table__table__head__row--modified">
									<div
										className={`data-table__table__head__title data-table__table__head__title--name data-table__table__head__title__sort-order link  ${getClassName("name")}`}
										id="dataElementId" onClick={
											(e) => {
												handleSort('name')
											}
										}>
										Name <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
											className={`data-table__table__head__title data-table__table__head__title--destination data-table__table__head__title__sort-order link ${getClassName("organization")}`}
											id="organization" onClick={
											(e) => {
												handleSort('organization')
											}
										}>
										Destination <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title--reference-number data-table__table__head__title__sort-order link ${getClassName("referenceNumber")}`}
										id="referenceNumber" onClick={
											(e) => {
												handleSort('referenceNumber')
											}
										}>
										Reference ID <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title--eclip-stats data-table__table__head__title__sort-order link ${getClassName("stats")}`}
										id="stats" onClick={
											(e) => {
												handleSort('stats')
											}
										}>
										Stats <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title--status data-table__table__head__title__sort-order link ${getClassName("status")}`}
										id="status" onClick={
											(e) => {
												handleSort('status')
											}
										}>
										Status <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title--created data-table__table__head__title__sort-order link data-table__table__body__content--modified ${getClassName("modified")}`}
										id="modified" onClick={
											(e) => {
												handleSort('modified')
											}
										}>
										Modified on <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
											className={`data-table__table__head__title data-table__table__head__title__sort-order link ${getClassName(currentPath.includes('shared') ? 'receiveOwner' : 'sendOwner')} data-table__table__head__title--package-owner`}
											id={currentPath.includes('shared') ? 'receiveOwner' : 'sendOwner'} onClick={
											(e) => {
												handleSort(currentPath.includes('shared') ? 'receiveOwner' : 'sendOwner')
											}
										}>
										Package Owner <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div className="data-table__table__head__title data-table__table__head__title--end data-table__table__body__content--modified">
										{/* Actions */}
									</div>

								</div>
							</div>
							<div className="data-table__table__body">
								{list?.length > 0 ?
									list :
									<div className="data-table__empty"><NoMessage /></div>
								}
							</div>
							{
								list?.length > 0 && (
									<div className="data-table__table__footer">
										<div className="data-table__table__footer__row">
											<div className="data-table__table__footer__row__left">
												<div className="data-table__table__pagination">
													<input className="data-table__table__pagination__page" type="number" value={currentPage} onChange={(e) => handleCurrnetInput(e)} min="1" max={meta?.totalPages} />
													<span className="data-table__table__pagination__page__meta"> of {meta?.totalPages || 1} pages </span>
													<button className="data-table__table__pagination__prev" onClick={() => goToPrev()} disabled={currentPage === 1 || !meta?.totalPages}><IconChevronDown /></button>
													<button className="data-table__table__pagination__next" onClick={() => goToNext()} disabled={currentPage === meta?.totalPages || !meta?.totalPages}><IconChevronDown /></button>
												</div>
											</div>
											<div className="data-table__table__footer__row__right">
												<div className="data-table__table__meta">
													Showing {getPageLabel(meta?.total, pageLimit, currentPage - 1)} of {meta?.total || 0} entries
												</div>
											</div>
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>
			</div>
			<ConfirmDeclineModal
				isVisible={isConfirmDeclineModalVisible}
				cancel={hideConfirmDeclineModal}
				confirm={(message)=>{
					onDeclineConfirm(selectedItem,message)
				}}
				title={"Decline Package"}
				packageName={selectedItem?.name}
			/>
			<MoveFolderModal
				visible={isShowMoveEcliptoFolderModal}
				close={hideEcliptoFolderModel}
				id={selectedItem.id}
				eclipFolderId={selectedItem?.eclipFolderId}
			/>
		</>


	)

}
